import React from 'react';
import { translate } from '../../../Services/translation';

const DescriptionTable = ({ fields }) => {

  return (
    <div className="description-table">
      <div className="description-table__row">
        <div className="description-table__row--left">
          {translate('product.table.attribute')}
        </div>
        <div className="description-table__row--middle">
          {translate('product.table.ref')}
        </div>
        <div className="description-table__row--right">
          {translate('product.table.value')}
        </div>
      </div>
      {fields.map((field) => (
        <div className="description-table__row" key={field.id}>
          <div className="description-table__row--left">{field.name}</div>
          <div className="description-table__row--middle">{field.ref}</div>
          <div className="description-table__row--right">{field.value} {field.unit}</div>
        </div>
      ))}
    </div>
  );
};

export default DescriptionTable;
